import React, { ReactElement } from 'react';
import { TdViewProps } from '../Td/Td.view';

export type TrViewProps = {
  //
  children: ReactElement<TdViewProps> | ReactElement<TdViewProps>[];
};

export const TrView = (props: TrViewProps): JSX.Element => {
  return <tr>{props.children}</tr>;
};
